export default __webpack_public_path__ + "static/media/npm.f787acc7.svg";